import client from "./axios";

// Le rotte football-match del backend sono montate SENZA prefisso /admin
// (solo requireUser): l'utente gestore è autenticato, quindi vanno bene.
const baseUrl = "https://internal-api.getmoveapp.com/api/v1/football-matches";

export type FootballSide = "team1" | "team2";

export type FootballMatchPlayer = {
  id: string;
  footballMatchId: string;
  userId?: string | null;
  guestName?: string | null;
  team: FootballSide;
  slot: number;
  goals?: number;
  confirmed?: boolean;
  noShow?: boolean;
  user?: {
    id?: string;
    name?: string;
    familyName?: string;
    photo?: string | null;
  } | null;
};

export type FootballMatch = {
  id: string;
  bookingId: string;
  teamSize: number;
  teamName1?: string;
  teamName2?: string;
  goalsTeam1?: number;
  goalsTeam2?: number;
  players?: FootballMatchPlayer[];
};

export const FootballMatchAPI = {
  getByBooking: (bookingId: string) =>
    client.get<{ result: FootballMatch | null }>(`${baseUrl}/get/${bookingId}`),
  createMatch: (body: { bookingId: string; teamSize?: number }) =>
    client.post<{ result: FootballMatch }>(`${baseUrl}/create`, body),
  addPlayer: (
    matchId: string,
    body: {
      userId?: string | null;
      guestName?: string | null;
      team: FootballSide;
      slot: number;
      addedById?: string | null;
    }
  ) =>
    client.post<{ result: FootballMatch }>(
      `${baseUrl}/${matchId}/add-player`,
      body
    ),
  removePlayer: (playerId: string) =>
    client.delete<{ result: string }>(`${baseUrl}/player/${playerId}`),
  updatePlayer: (
    playerId: string,
    body: { team?: FootballSide; slot?: number; guestName?: string | null }
  ) => client.put<{ result: string }>(`${baseUrl}/player/${playerId}`, body),
  setTeamNames: (
    matchId: string,
    body: { teamName1?: string; teamName2?: string }
  ) =>
    client.put<{ result: FootballMatch }>(`${baseUrl}/${matchId}/team-names`, body),
};
